export default __webpack_public_path__ + "static/media/pickAndMove.31372a6f.svg";